import BlockReplacement from './base/block-replacement';
export default BlockReplacement.extend().reopenClass({
  replacement: {
    pattern: /(?:[\s\S])?^(1[\)\.] )(.+)?$/m,
    replaceWith: 'OrderedList',
    captureGroupMapping: ['trigger', 'blockList.firstObject.text']
  }
});